import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router, CanActivateChild } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { UserFactory } from './user.factory';
import { environment } from 'src/environments/environment';
import { UtilityService } from '../services/utility.service';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { TranstationFactory } from './translation.factory';
import { TranslateService } from '@ngx-translate/core';
import { LocalizeRouterService } from 'localize-router';

const DATE_FORMAT_DEFAULT = 'DD MMM YYYY';

@Injectable()
export class CanActivateAuthGuard implements CanActivate, CanActivateChild {

    navigate: any;

    constructor(
        private authService: AuthenticationService,
        private route: Router,
        private userFactory: UserFactory,
        private utilityService: UtilityService,
        private transtationFactory: TranstationFactory,
        private translate: TranslateService,
        private localize: LocalizeRouterService,
    ) {
        const navigate = this.route.getCurrentNavigation();
        this.navigate = navigate;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const code = state.root.queryParams.code;
        const refresh = state.root.queryParams.refresh;

        console.log('refresh', refresh);

        if (this.authService.isAuthenticated()) {
            return true;
        } else {
            if (code != undefined) {
                this.userFactory.saveToken(code);
                this.userFactory.saveRefreshToken(refresh);
                this.authService.getAgentProfile().subscribe(res => {
                    const profile = res['agentProfileDetail'];
                    this.userFactory.saveProfile(profile.agentId);
                    const urlDestination = environment.urlDestination + `${localStorage.getItem('state')}`;
                    window.location.href = urlDestination;
                });
            } else {
                if (environment.isSso) {
                    /* new log-in (adb2c)*/
                    // const state = this.utilityService.generateStateSSO();
                    const urlLoginWithADB2C = `${environment.ssoLoginUrl}?` + `${environment.responseType}` + `&state=${btoa(state.url)}` + `&${environment.scope}` + `&${environment.clientId}` + `&${environment.redirectPath}`;
                    localStorage.setItem('state', state.url);
                    console.log('url: ', urlLoginWithADB2C);
                    window.location.href = urlLoginWithADB2C;
                    return false;
                } else {
                    /* old log-in */
                    this.route.navigate([this.userFactory.getCurrentLang() + environment.path.login], {
                        queryParams: {
                            return: state.url
                        }
                    });
                    return false;
                }
            }
        }
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    checkExpireDate(res) {
        if (res['isPass'] === 'Y') {
            const nowDate = moment(new Date()).startOf('day');
            const date = new Date(res.agentProfileDetail.licenseExpired);
            let expireDate = moment(date);
            const years = expireDate.diff(nowDate, 'years');
            const months = expireDate.diff(nowDate, 'months') - (years * 12);
            const days = expireDate.diff(nowDate, 'days');

            expireDate = this.translate.currentLang === 'th' ? expireDate.add(543, 'year') : expireDate;
            const dateStr = expireDate.format(DATE_FORMAT_DEFAULT);

            const massage = this.transtationFactory.get('expire_warning_text')
                + days + this.transtationFactory.get('expire_warning_text_day')
                + dateStr;

            if (days <= 60) {
                Swal.fire({
                    title: this.transtationFactory.get('expire_warning'),
                    text: massage,
                    type: 'warning',
                    confirmButtonText: this.transtationFactory.get('button.close')
                });
            }
        }
    }
}
